/**
 * Approved legal identity facts for the app legal, terms, and account-deletion
 * routes (Release 2.0.0, task T05).
 *
 * Sourced from `15-T05-LEGAL-DECISION-AND-CONTENT-BRIEF.md` and the founder
 * decisions in `17-T05-CONFLICT-RESOLUTION.md`. Every legal page reads its
 * publisher, effective date, and app legal version from here so the six routes
 * cannot drift apart. The support address stays in siteContent (T03) and is not
 * duplicated here.
 *
 * Changing any value in this file is a legal-wording decision, not a code
 * change: it needs founder approval before publication.
 */

export const PUBLISHER = 'Bharatkumar Leel, Founder of TickleApps';
export const EFFECTIVE_DATE = '21 September 2026';

export const APP_LEGAL = {
  nutriscan: {
    name: 'NutriScan',
    version: 'NutriScan 1.4.0',
    // Founder decision (17-T05): 1.4.0 has no rewarded ads and no AdMob.
    freeAllowance: '3 scans in a rolling 24-hour period',
  },
  cardcycle: {
    name: 'CardCycle',
    version: 'CardCycle 0.3.0',
  },
};

// Deletion request window for a verified NutriScan account-deletion request.
export const NUTRISCAN_RECOVERY_WINDOW = '30 days';
